/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const ACTION = {
	INVOCATION: {
		/** 10 seconds */
		DEFAULT_TIMEOUT: 10 * 1000,
		/** 1 second */
		MIN_TIMEOUT: 1 * 1000,
		/** % minutes */
		MAX_TIMEOUT: 5 * 60 * 1000,
		/** Max recursion level */
		NODE_MAX_RECURSION: 3000
	},
	NODES: {
		TRANSFORM: {
			/** VM memory limit in megabytes */
			MEMORY_LIMIT: 512
		}
	}
};
